<template>
  <div class="made-order">
    <Row>
      <Col :xs="24" :sm="24">
        <Form :model="formItem" ref="formItem" :inline="true" action="javascript:void(0)">
          <FormItem>
            <Input v-model="formItem.order_num" clearable placeholder="输入支付订单号..."></Input>
          </FormItem>
          <FormItem>
            <Input v-model="formItem.key" clearable placeholder="输入材料名或者手机号..."></Input>
          </FormItem>
          <FormItem>
            <DatePicker
              type="datetimerange"
              format="yyyy-MM-dd"
              @on-change="changeDate"
              style="width: 260px"
              placeholder="下单时间"
            ></DatePicker>
          </FormItem>
          <FormItem>
            <Button type="primary" @click="renderTable('formItem')">查找</Button>&nbsp;
            <Button type="success" :loading="exportLoading" @click="exportOrder()">导出订单</Button>
          </FormItem>
        </Form>
      </Col>
    </Row>
    <Table
      max-height="600"
      border
      :columns="list"
      :data="tablelist"
      :loading="dataloading"
      class="B2CList"
    ></Table>
    <div style="margin: 10px;overflow: hidden">
      <div style="float: right;">
        <Page
          ref="listPage"
          :total="pages.total"
          :current="pages.current"
          :page-size="pages.size"
          show-elevator
          show-total
          @on-change="changePage()"
        ></Page>
      </div>
    </div>
  </div>
</template>

<script>
// import expandRow from "./table-expand";

export default {
  name: "made-order",
  data() {
    return {
      orderStatusList: [
        { value: 1, label: "正常" },
        { value: 2, label: "完成" },
        { value: 0, label: "关闭" }
      ],
      payStatusList: [
        { value: 0, label: "未支付" },
        { value: 1, label: "支付中" },
        { value: 2, label: "支付完成" }
      ],
      dataloading: true,
      formItem: {
        key: "",
        datetime: []
      },
      payNameList: [],
      pages: {
        current: 1,
        total: 0,
        size: 10
      },
      list: [
        {
          title: "id",
          key: "id",
          width: 80
          // fixed:"left"
        },
        {
          title: "支付订单号",
          key: "pay_order_num",
          width: 185
          // fixed:"left"
        },
        {
          title: "下单用户",
          width: 120,
          render: (h, params) => {
            return h(
              "span",
              params.row.user != null ? params.row.user.username : ""
            );
          }
        },
        {
          title: "材料",
          width: 100,
          render: (h, params) => {
            return h(
              "span",
              params.row.data != null ? params.row.data.name : ""
            );
          }
        },
        {
          title: "单价",
          key: "price",
          width: 80
        },
        {
          title: "数量",
          key: "nums",
          width: 80
        },
        {
          title: "支付金额",
          key: "total_price",
          width: 100
        },
        {
          title: "支付方式",
          width: 100,
          align: "center",
          key: "pay_name"
        },
        {
          title: "支付状态",
          width: 100,
          align: "center",
          key: "pay_status",
          render: (h, params) => {
            return h(
              "div",
              params.row.pay_status == "0"
                ? "未支付"
                : params.row.pay_status == "1"
                ? "支付中"
                : "已完成"
            );
          }
        },
        {
          title: "订单状态",
          width: 100,
          align: "center",
          key: "status",
          render: (h, params) => {
            return h(
              "tag",
              {
                props: {
                  color:
                    params.row.order_status == "0"
                      ? "red"
                      : params.row.order_status == "1"
                      ? "orange"
                      : "geekblue"
                }
              },
              params.row.order_status == "0" ? "正常" : "关闭"
            );
          }
        },
        {
          title: "下单时间",
          minWidth: 150,
          key: "created_at"
        },
        {
          title: "支付时间",
          minWidth: 150,
          key: "pay_at"
        },
        {
          title: "融宝返回信息",
          minWidth: 150,
          key: "wx_return_status"
        }
        // {
        //   title: "操作",
        //   align: "center",
        //   key: "action",
        //   width: 150,
        //   // fixed: 'right',
        //   render: (h, params) => {
        //     return h("div", [
        //       h(
        //         "Button",
        //         {
        //           props: {
        //             type: "primary",
        //             size: "small"
        //           },
        //           style: {
        //             marginRight: "5px",
        //             display:
        //               params.row.order_status == "1" &&
        //               params.row.pay_status < 3
        //                 ? "inline-block"
        //                 : "none"
        //           },
        //           on: {
        //             click: () => {
        //               this.cancelorder(params.row.id);
        //             }
        //           }
        //         },
        //         "详情"
        //       )
        //     ]);
        //   }
        // }
      ],
      tablelist: [],
      exportLoading: false
    };
  },
  mounted: function() {
    // 取数据
    this.getTableList();
  },
  methods: {
    // 获取订单列表
    getTableList: function() {
      this.renderTable(1);
      return;
    },
    changeDate(val) {
      this.formItem.datetime = val;
    },

    // 分页
    changePage() {
      this.pages.current = this.$refs["listPage"].currentPage;
      this.renderTable(1);
    },

    cancelorder: function(index) {
      // 弹出确认框
      //   this.$Modal.confirm({
      //     title: "警告",
      //     content: "<p>此操作不可恢复，三思而后行...</p>",
      //     onOk: () => {
      //       this.$api.madeorder.cancel({ id: index }).then(res => {
      //         if (res.code == 200) {
      //           this.renderTable(1);
      //         }
      //       });
      //     }
      //   });
    },
    perChange: function(index) {
      this.logistics_id = index.value;
      this.logistics_name = index.label;
    },
    // 筛选
    renderTable: function(name) {
      if (name != 1) {
        this.pages.current = 1;
      }
      var pay_begin_at =
        this.formItem.datetime[0] != undefined ? this.formItem.datetime[0] : "";
      var pay_end_at =
        this.formItem.datetime[1] != undefined ? this.formItem.datetime[1] : "";
      let params = {
        page: this.pages.current,
        size: this.pages.size,
        key: this.formItem.key,
        order_num: this.formItem.order_num,
        pay_begin_at: pay_begin_at,
        pay_end_at: pay_end_at
      };
      this.$api.mangheorder.dataOrderList(params).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.tablelist = res.result.list;
          this.pages.total = res.result.total;
          this.payNameList = res.result.payNameList;
          this.$Message.success(res.msg);
        }
      });
    },
    exportOrder() {
      this.exportLoading = true;
      var pay_begin_at =
        this.formItem.datetime[0] != undefined ? this.formItem.datetime[0] : "";
      var pay_end_at =
        this.formItem.datetime[1] != undefined ? this.formItem.datetime[1] : "";
      this.$api.mangheorder
        .exportdataorder({
          pay_begin_at: pay_begin_at,
          pay_end_at: pay_end_at
        })
        .then(res => {
          if (res.code == 200) {
            // window.location.href = res.result;
            this.$Message.success(res.msg);
          }
          this.exportLoading = false;
        });
    }
  }
};
</script>

<style scoped>
</style>